import React, { Component } from "react";
import CustomSelect from "../../components/common/select/Select";
import DownloadIcon from "../../assets/images/downloadIcon.svg";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import CategoryMiddleware from "../../store/middleware/categoryMiddleware";
import BrandsMiddleware from "../../store/middleware/brandsMiddleware";
import SkusMiddleware from "../../store/middleware/skusMiddleware";
import RegionsMiddleware from "../../store/middleware/regionMiddleware";
import DemandDriverMiddleware from "../../store/middleware/demandDriverMiddleware";
import DemandPlannerMiddleware from "../../store/middleware/demandPlannerMiddleware";
import "./DemandPlanner.styles.scss";
import DownloadDPXlxMiddleware from "../../store/middleware/downloadDPXlxMiddleware";
import UploadDPXlxMiddleware from "../../store/middleware/uploadDPMiddleware";
import $ from "jquery";
import PopUpModal from "../../components/common/popup-modal/PopUpModal";
import DATA from "../../assets/data";
import { Loader } from "../../components/loader";
import Downloading from "../../assets/gifs/Downloading.gif";
import { Prompt } from "react-router";
import { compare } from '../../prat_screen/gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx';

import DemandPlannerWeekly from '../../components/demand-planner-components/demand-planner-weekly/demandPlannerWeekly';
import DemandPlannerTabs from '../../components/demand-planner-components/demand-planner-tabs/demandPlannerTabs';
import DemandPlannerSecMat from '../../components/demand-planner-components/demand-planner-sec-mat/demandPlannerSecMat';
import DemandPlannerSecMatSaleMsku from '../../components/demand-planner-components/demand-planner-sec-mat-sale-msku/demandPlannerSecMatMsku';
import DemandPlannerYoySec from '../../components/demand-planner-components/demand-planner-yoy-sec/demandPlannerYoySec';

let selectedBrandFinal = [];
window.onbeforeunload = (e) => {
  // I'm about to refresh! do something...
  alert('heelo')
};
export class DemandPlanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myTempSkus: [],
      myTempBrands: [],
      myBrands: [],
      mySkus: [],
      selectedValue: "",
      isLoading: false,
      category: [],
      selectedCategory: '',
      selectedBrand: [],
      selectedSku: [],
      selectedYear: null,
      page: 1,
      weekFrom: "",
      weekTo: "",
      selectedForecast: true,
      years: [
        { value: "2020" },
        { value: "2021" },
      ],
      forecasted: [
        { name: 'Machine Generated', value: true },
        { name: 'Human Generated', value: false }
      ],
      data: [],
      popedValue: "",
      selectedFile: null,
      isAuthrizedForDownload: false,
      isLoadingInitial: true,
      isOpen: false,
      switch: true,
      selectedWeekFrom: '',
      selectedCOTC: [],
      myCOTC: [
        { name: 'COTC', value: 'COTC' },
        { name: 'ROB', value: 'ROB' },
        { name: 'Future Core', value: 'Future Core' }
      ],
      getStandPoint: true,
      activeTabIndex: 0,
      demandPlannerSecMatData:null,
      demandPlannerSecMatSaleMsku:null,
      demandPlannerSecYoy:null,
      getDataFromChild:false,
      isMonthly:false
    };
  }
  handleOpen = () => {
    this.setState({
      isOpen: true,
    });
  };
  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  propsReceived = (value) => {
    Object.entries(value).forEach((item) => this.state.data.push(item[1]));
    if(this.state.data?.length){
      if (this.state.getStandPoint) {
        let snapShot = (Object.entries(value)[0][1].Snapshot).toString();
        // let snapShot = ''
  
        this.setState({
          selectedWeekFrom: snapShot,
          getStandPoint: false
        })
      }
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.demandPlanner && this.props?.isDemandPlannerLoading) {
      if (nextProps.demandPlanner.data) {
        this.propsReceived(nextProps.demandPlanner.data);
        this.setState({
          isLoadingInitial: false,
          getDataFromChild:true
        })
      }
    }
    if(nextProps.demandPlannerSecMat && nextProps.demandPlannerSecMat?.status === 200){
      this.setState({
        demandPlannerSecMatData: nextProps.demandPlannerSecMat.data
      })
    }
    if(nextProps.demandPlannerSecMatSaleMsku && nextProps.demandPlannerSecMatSaleMsku?.status === 200){
      this.setState({
        demandPlannerSecMatSaleMsku: nextProps.demandPlannerSecMatSaleMsku.data
      })
    }
    if(nextProps.demandPlannerSecYoy && nextProps.demandPlannerSecYoy?.status === 200){
      this.setState({
        demandPlannerSecYoy: nextProps.demandPlannerSecYoy.data
      })
    }
    else{
      this.setState({
        demandPlannerSecYoy: nextProps.demandPlannerSecYoy?.data
      })
    }
  }

  load_Skus =()=> {
    if (this.props.isDemandPlannerLoading || this.props.demandPlannerHasError)
      return;
    this.setState(
      {
        page: this.state.page + 1,
      },
      () => {
        this.props.getDemandPlanner(
          this.state.page,
          this.state.selectedCategory,
          this.state.selectedBrand,
          this.state.selectedSku,
          this.state.selectedYear,
          this.state.weekFrom,
          this.state.weekTo,
          this.state.selectedForecast,
          this.state.selectedWeekFrom,
          this.state.selectedCOTC
        );
      }
    );
  }

  // load_more = throttle(this.load_Skus, 800, {
  //   trailing: false,
  // });

  onUnload(event) {
    alert('page Refreshed')
  }
  UNSAFE_componentWillMount() {
    window.onbeforeunload = undefined;
  }
  componentDidMount() {


    let data = JSON.parse(window.localStorage.getItem("myData"));
    data.user.groups.includes("DP")
      ? this.setState({ isAuthrizedForDownload: true })
      : this.setState({ isAuthrizedForDownload: false });
    setTimeout(() => {
      this.props.getCategory();
      this.props.getBrands();
      this.props.getSkus();
      // setTimeout(() => {
      //   this.getDataOnComponentMount();
      // }, 2000);
    }, 1000);
  }

  getDataOnComponentMount = () => {
    // setTimeout(() => {
      this.setState(
        {
          page: 1,
          selectedCategory: this.props.category[0].guid,
          // selectedCategory: '040af7ec-5ca5-4740-b899-9dbc48167599',
          selectedYear: 2020,
          weekFrom: 1,
          weekTo: 52,
          selectedForecast: true,
        },
        () => {
          this.getBrands();
            this.props.getDemandPlanner(
              this.state.page,
              this.state.selectedCategory,
              this.state.selectedBrand,
              this.state.selectedSku,
              this.state.selectedYear,
              this.state.weekFrom,
              this.state.weekTo,
              this.state.selectedForecast,
              this.state.selectedWeekFrom,
              this.state.selectedCOTC
            );
      //   },
      //   1000
      // );
    });
  };

  getBrands = () => {
    try {
      const {
        selectedCategory,
      } = this.state;
      const { brands } = this.props;
      let filteredbrands = [];
      if (selectedCategory) {
        for (let i = 0; i < 1; i++) {
          filteredbrands.push(
            ...brands.filter((item) => {
              return item.Category === selectedCategory;
            })
          );
        }
      }
      this.setState({
        myBrands: filteredbrands,
      },
        () => {
          let selectBrands = [];
          this.state.myBrands.length &&
            this.state.myBrands.forEach(item => selectBrands.push(item.guid));
          this.setState({
            selectedBrand: selectBrands
          },
          ()=>{
            this.getSkus();
          });
        });
    } catch (error) { }
  };

  getSkus = () => {
    try {
      setTimeout(() => {
        const { selectedBrand } = this.state;
        const { skus } = this.props;
        let filteredSkus = [];
        if (selectedBrand.length) {
          for (let i = 0; i < selectedBrand.length; i++) {
            filteredSkus.push(
              ...skus.filter((item) => {
                return item.Brand === selectedBrand[i];
              })
            );
          }
        }
        this.setState({
          mySkus: filteredSkus,
        });
      }, 1000);
    } catch (error) {
      console.log(error)
    }
  };

  handleFilteredBrands = () => {
    const {
      selectedCategory,
      myBrands,
      selectedBrand,
      mySkus,
      selectedSku,
    } = this.state;
    const { brands } = this.props;
    let filteredbrands = [];
    if (selectedCategory.length) {
      for (let i = 0; i < selectedCategory.length; i++) {
        filteredbrands.push(
          ...brands.filter((item) => {
            return item.Category === selectedCategory[i];
          })
        );
      }
      selectedBrandFinal = [];
      myBrands.forEach((element) => {
        if (selectedBrand.length !== 0) {
          selectedBrand.forEach((e) => {
            if (element.guid === e) {
              selectedBrandFinal.push(e);
              this.setState({
                selectedBrand: selectedBrandFinal,
                newSelectedBrand: selectedBrandFinal,
              });
              if (selectedSku.length !== 0) {
                mySkus.forEach((skuElement, i) => {
                  selectedBrandFinal.forEach((se) => {
                    if (skuElement.Brand === se) {
                      selectedSku.forEach((el) => {
                        if (skuElement.guid === el) {
                          this.setState({
                            selectedSku: [],
                          });
                        }
                      });
                    }
                  });
                });
              }
            }
          });
        }
      });

      this.setState({
        myBrands: filteredbrands,
      });
    }
  };
  handleFilteredSkus = () => {
    const { selectedBrand, selectedSku, mySkus } = this.state;
    const { skus } = this.props;
    let filteredSkus = [];
    if (selectedBrand.length) {
      for (let i = 0; i < selectedBrand.length; i++) {
        filteredSkus.push(
          ...skus.filter((item) => {
            return item.Brand === selectedBrand[i];
          })
        );
      }

      let selectedSkuFinal = [];
      mySkus.forEach((element) => {
        if (selectedSku.length !== 0) {
          selectedSku.forEach((e) => {
            if (element.guid === e) {
              selectedSkuFinal.push(e);
              this.setState({
                selectedSku: selectedSkuFinal,
              });
            }
          });
        }
      });

      this.setState({
        mySkus: filteredSkus,
      });
    }
  };

  handleChange = (selectedValue) => {
    // let arr = [];
    if (selectedValue === null || selectedValue === '') {
      this.setState({
        selectedCategory: '',
        myBrands: [],
        selectedBrand: [],
        selectedSku: [],
        mySkus: [],
      });
    } else {
      this.setState({ selectedCategory: selectedValue.value,selectedSku:[] }, () => {
        this.getBrands();
      });
    }
  };

  handleBrandChange = (selectedValue) => {
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({ selectedBrand: [], selectedSku: [], mySkus: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedBrand: arr }, () => {
        this.handleFilteredSkus();
      });
    }
  };

  handleSkus = (selectedValue) => {

    let duplicateArray = Array.isArray(selectedValue) ? selectedValue : [selectedValue]
    let arr = [];
    if (duplicateArray[0] === null || duplicateArray.length===0) {
      this.setState({ selectedSku: [] });
    } else {
      duplicateArray.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedSku: arr });
    }
  };

  handleCotc = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedCOTC: selectedValue.value,
      });
    } else {
      this.setState({
        selectedCOTC: "",
      });
    }
  }

  handleYear = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedYear: selectedValue.value,
      });
    }
  };
  handleForecast = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedForecast: selectedValue.value,
      });
    }
  };

  handleSubmit = (e) => {
    switch (this.state.activeTabIndex) {
      case 0:
        this.fetchDemandPlannerWeekly();
        return
      case 5:
        this.fetchDemandPlannerSecMat();
        return
      case 7:
        this.fetchDemandPlannerSecMatSaleMsku();
        return
      case 9:
        this.fetchDemandPlannerSecYoy();
        return
      default:
        return
    }
    
  };

  fetchDemandPlannerSecMatSaleMsku = () => {
    if(this.state.selectedSku.length){
      if(this.state.selectedSku.length > 1){
        this.setState({
          selectedSku: []
        })
      }
      else{
        this.props.getDemandPlannerSecMatSaleMsku(
          this.state.selectedSku
        )
      }
    }
    else{
      CustomToast('error',"MSKU is not selected!")
    }
  }

  fetchDemandPlannerSecMat = () => {
    if(this.state.selectedCategory && this.state.selectedBrand){

      this.props.getDemandPlannerSecMat(
        this.state.selectedCategory,
        this.state.selectedBrand,
        this.state.selectedSku
      );
    }
  }

  fetchDemandPlannerSecYoy = () => {
    if(this.state.selectedCategory){

      this.props.getDemandPlannerSecYoy(
        this.state.selectedCategory,
        this.state.selectedBrand,
        this.state.selectedSku
      );
    }
  }

  fetchDemandPlannerWeekly=()=>{
    if (
      parseInt(this.state.weekTo) < 1 ||
      parseInt(this.state.weekTo) > 52 ||
      isNaN(this.state.weekTo) ||
      parseInt(this.state.weekFrom) < 1 ||
      parseInt(this.state.weekFrom) > 52 ||
      isNaN(this.state.weekFrom)
    ) {
      CustomToast('error',"Enter Correct Week!")
    } else {
      this.setState(
        {
          data: [],
          popedValue: "",
          page: 1
        },
        () => {
          const {
            page,
            selectedCategory,
            selectedBrand,
            selectedSku,
            selectedYear,
            weekFrom,
            weekTo,
            selectedForecast,
            selectedWeekFrom,
            selectedCOTC
          } = this.state;
          if (this.state.selectedCategory) {
              this.setState({
                isLoadingInitial: true
              })
              this.props.getDemandPlanner(
                page,
                selectedCategory,
                selectedBrand,
                selectedSku,
                selectedYear,
                weekFrom,
                weekTo,
                selectedForecast,
                selectedWeekFrom,
                selectedCOTC
              );
          } else {
              CustomToast('error', "Category is not selected!")
          }
        }
      );
    }
  }

  handleWeekChange = (e) => {
    let nam = e.target.name;
    let val = e.target.value;
    this.setState({
      [nam]: val,
    });
  };

  handleDownload = (e) => {
    e.preventDefault();
    const {
      page,
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedYear,
      weekFrom,
      weekTo,
      selectedForecast,
      selectedWeekFrom,
      selectedCOTC,
      isMonthly
    } = this.state;
    if (this.state.selectedCategory) {
        this.props.downloadXlx(
          page,
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedYear,
          weekFrom,
          weekTo,
          selectedForecast,
          selectedWeekFrom,
          selectedCOTC,
          isMonthly
        );
    } else {
        CustomToast('error', "Category is not selected!")
    }
  };
  handleFileUpload = (e) => {
    if (e.target.files[0] === undefined) {
      return;
    } else {
      var extension = e.target.files[0].name.split(".").pop().toLowerCase();
      var allowed = ["xls", "xlsx"];
      if (allowed.indexOf(extension) === -1) {
        // ToastsStore.error("Invalid File Type!");
              CustomToast('error', "Invalid File Type!")
      } else {
        this.setState(
          {
            selectedFile: e.target.files[0],
          },
          () => {
            this.props.uploadXlx(this.state.selectedFile);
          }
        );
      }
    }
  };

  handleScroll = (e) => {
    var ignoreScrollEvents = false;
    function syncScroll(element1, element2) {
      element1.scroll(function (e) {
        var ignore = ignoreScrollEvents;
        ignoreScrollEvents = false;
        if (ignore) return;

        ignoreScrollEvents = true;
        element2.scrollTop(element1.scrollTop());
      });
    }
    syncScroll($("#div2"), $("#div1"));

    if (this.props.isDemandPlannerLoading) return;
    let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;
    if (bottom) {
      this.load_more()
    }
  }



  handleLoading = () => {
    if (this.props.isDemandPlannerLoading || (this.props.demandPlanner === undefined)) {
      return <Loader flag={true} />
    }
  };
  // componentDidUpdate = () => {
  //   if (this.props.isFileUpLoading) {
  //     window.onbeforeunload = () => true
  //   } else {
  //     window.onbeforeunload = undefined
  //   }
  // }

  handleWeekFromChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedWeekFrom: selectedValue.value,
      });
    } else {
      this.setState({
        selectedWeekFrom: "",
      });
    }
  }

  handleTabToggle = (ind) => {
    this.setState({
      activeTabIndex: ind,
      weekTo: ind === 0 ? 52 : 12,
      isMonthly: ind === 0 ? false : true,
    })
  }

  componentDidUpdate(prevProps, prevState){
    if((prevProps.category !== this.props.category)){
      this.getDataOnComponentMount();
    }
    if(prevProps.brands !== this.props.brands){
      this.getBrands();
    }

  }

  render() {
    const { category } = this.props;
    this.handleLoading()
    return (
      <>
        {this.props.isFileUpLoading && (
          <Prompt
            when={this.props.isFileUpLoading}
            message="File is uploading, are you sure you want to leave?"
          />
        )}
        <div className="page-container">

          {/* {(this.props.isDemandPlannerLoading && this.state.isLoadingInitial) || (this.state.isLoadingInitial) || (this.props.demandPlanner === undefined) ? <Loader flag={true} />

            :

            <> */}

              <div className="heading-and-download-container">

                <span className='component-heading'>Demand Planner</span>

                <div className='dp-cta-container'>

                  <p className="see-version" onClick={this.handleOpen}>
                    <img className='image-margin' src={require('../../assets/images/history.svg')} alt='' />
                    <u>Version History</u>
                  </p>

                  {this.state.isAuthrizedForDownload && <div style={{ marginRight: '10px' }}>
                    {

                      (this.props.isFileUpLoading ? (
                        <img
                          src={Downloading}
                          style={{ width: "26.66px", height: "31.98px", transform: 'rotate(180deg)' }}
                          alt='' />
                      ) : (
                          <div className='upload-image-container'>
                            <img src={require('../../assets/images/uploadExcelIcon.svg')} alt='' />
                            <input
                              type="file"
                              className="input-upload"
                              onChange={(e) => this.handleFileUpload(e)}
                            />
                          </div>
                        ))
                    }
                  </div>}

                  <div>

                    {this.props.isFileDownloading ? (
                      <img
                        src={Downloading}
                        style={{ width: "26px", height: "31px" }}
                        alt='' />
                    ) : (
                        <img
                          src={DownloadIcon}
                          onClick={this.handleDownload}
                          // className="download-xlx-img"
                          alt="xldownload"
                        />
                      )}
                  </div>

                </div>

              </div>

              <div className="select-container">
                <div className='filters-container-only'>
                  <CustomSelect.MyCustomSelect
                    placeholder={"Category"}
                    className='select-box'
                    // allowSelectAll={true}
                    // isMulti
                    options={
                      category
                        ? category.sort(compare).map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })
                        : []
                    }
                    onChange={this.handleChange}
                    value={
                      category
                        ? category
                          .filter(item => {
                            return !this.state.selectedCategory
                              ? void 0
                              : item.guid === this.state.selectedCategory;
                          })
                          .map((item) => {
                            return {
                              value: item.guid,
                              label: item.Name,
                            };
                          })
                        : []
                    }
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Brands"}
                    allowSelectAll={true}
                    isMulti
                    options={
                      this.state.myBrands
                        ? this.state.myBrands.sort(compare).map((item) => ({
                          value: item.guid,
                          label: item.Name,
                        }))
                        : []
                    }
                    onChange={this.handleBrandChange}
                    value={this.state.myBrands
                      .filter((item) => {
                        return this.state.selectedBrand.includes(item.guid);
                      })
                      .map((item) => {
                        return {
                          value: item.guid,
                          label: item.Name,
                        };
                      })}
                  />
                  <CustomSelect.MyCustomSelect
                    placeholder={"MSKUs"}
                    className={this.state.activeTabIndex === 7 ? 'select-box' :''}
                    allowSelectAll={this.state.activeTabIndex === 7 ? false : true}
                    isMulti={this.state.activeTabIndex === 7 ? false : true}
                    options={
                      this.state.mySkus
                        ? this.state.mySkus.sort(compare).map((item) => ({
                          value: item.guid,
                          label: item.Description,
                        }))
                        : []
                    }
                    onChange={this.handleSkus}
                    value={this.state.mySkus
                      .filter((item) => {
                        return this.state.selectedSku.includes(item.guid);
                      })
                      .map((item) => {
                        return {
                          value: item.guid,
                          label: item.Description,
                        };
                      })}
                  />
                  {
                    this.state.activeTabIndex === 4 ||
                    this.state.activeTabIndex === 5 ||
                    this.state.activeTabIndex === 6 ||
                    this.state.activeTabIndex === 7 ||
                    this.state.activeTabIndex === 8 ||
                    this.state.activeTabIndex === 9 
                    ?
                      null
                    :
                    <>
                  <CustomSelect.MyCustomSelect
                    placeholder={"Core Type"}
                    className='select-box'
                    isClearable={true}
                    options={
                      this.state.myCOTC
                        ? this.state.myCOTC.map((item) => ({
                          value: item.value,
                          label: item.name,
                        }))
                        : []
                    }
                    onChange={this.handleCotc}
                    value={this.state.myCOTC
                      .filter((item) => {
                        return this.state.selectedCOTC.includes(item.value);
                      })
                      .map((item) => {
                        return {
                          value: item.value,
                          label: item.name,
                        };
                      })}
                  />
                  <CustomSelect.MySelect
                    placeholder={"Years"}
                    options={this.state.years.map((item) => ({
                      value: item.value,
                      label: item.value,
                    }))}
                    onChange={this.handleYear}
                    value={
                    this.state.years && this.state.years.filter(item=>{
                  return item.value == this.state.selectedYear       // eslint-disable-line
                })
              .map(item => {
                return {
                  value: item.value,
                  label: item.value
                };
              })
                  }
                  />

                  <CustomSelect.MyCustomSelect
                    placeholder={"Version"}
                    className='select-box dp-version-filter'
                    // isClearable={true}
                    options={
                      this.state.forecasted.map((item) => ({
                        value: item.value,
                        label: item.name,
                      }))
                    }
                    onChange={this.handleForecast}
                    value={this.state.forecasted
                      .filter(item => {
                        return item.value === this.state.selectedForecast;
                      })
                      .map(item => {
                        return {
                          value: item.value,
                          label: item.name
                        };
                      })}
                  />

                  {/* {this.state.selectedForecast ? */}
                    <CustomSelect.MyCustomSelect
                      placeholder="Stand Point"
                      className='select-box'
                      isClearable={true}
                      options={DATA.WEEK_NO.map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      onChange={this.handleWeekFromChange}
                      value={DATA.WEEK_NO
                        ? DATA.WEEK_NO
                          .filter(item => {
                            return !this.state.selectedWeekFrom
                              ? void 0
                              : item.value === this.state.selectedWeekFrom;
                          })
                          .map(item => {
                            return {
                              value: item.value,
                              label: item.label
                            };
                          })
                        : void 0
                      }
                    />
                    {/* :
                    null} */}
                    </>
                    }

                </div>

                <Button
                  variant="outlined"
                  className="submit-btn"
                  onClick={(e) => this.handleSubmit(e)}
                  style={{ marginBottom: '8px' }}
                >
                  SUBMIT
            </Button>
              </div>

              <DemandPlannerTabs 
              handleTabToggle = {this.handleTabToggle}
              activeTabIndex={this.state.activeTabIndex}
              />

              {/* <div>{this.dptable()}</div> */}
              {
                this.state.activeTabIndex === 0 && this.props.category?.length ?
                <DemandPlannerWeekly state={this.state}
                  DATA={DATA}
                  isDemandPlannerLoading={this.props.isDemandPlannerLoading}
                  load_Skus={this.load_Skus}
                  fetchDemandPlannerWeekly={this.fetchDemandPlannerWeekly}
                  isLoadingInitial={this.state.isLoadingInitial}
                  getDataFromChild={this.state.getDataFromChild}
                  />
                  : 
                  null
               }

               {
                 this.state.activeTabIndex === 5 ?
                 <DemandPlannerSecMat
                  data={this.state.demandPlannerSecMatData && this.state.demandPlannerSecMatData}
                  isDemandPlannerSecMatLoading={this.props.isDemandPlannerSecMatLoading}
                  fetchDemandPlannerSecMat={this.fetchDemandPlannerSecMat}
                 />
                 :
                 null
               }

               {
                 this.state.activeTabIndex === 7 ?
                 <DemandPlannerSecMatSaleMsku
                  data={this.state.demandPlannerSecMatSaleMsku && this.state.demandPlannerSecMatSaleMsku}
                  isDemandPlannerSecMatSaleMskuLoading={this.props.isDemandPlannerSecMatSaleMskuLoading}
                  fetchDemandPlannerSecMatSaleMsku={this.fetchDemandPlannerSecMatSaleMsku} 
                 />
                 :
                 null
               }

               {
                 this.state.activeTabIndex === 9 ?
                 <DemandPlannerYoySec
                  data={this.state.demandPlannerSecYoy && this.state.demandPlannerSecYoy}
                  isDemandPlannerSecYoyLoading={this.props.isDemandPlannerSecYoyLoading}
                  fetchDemandPlannerSecYoy={this.fetchDemandPlannerSecYoy} 
                 />
                 :
                 null
               }

              <PopUpModal
                handleOpen={this.handleOpen}
                isOpen={this.state.isOpen}
                handleClose={this.handleClose}
              />
            {/* </>
          } */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.CategoryReducer.isLoading,
    category: state.CategoryReducer.category,
    isCategoryLoading: state.CategoryReducer.isCategoryLoading,
    brands: state.BrandsReducer.brands,
    skus: state.SkusReducer.skus,
    regions: state.RegionReducer.regions,
    demandDriver: state.DemandDriverReducer.demandDriver,
    demandPlanner: state.DemandPlannerReducer.demandPlanner,
    isDemandPlannerLoading: state.DemandPlannerReducer.isDemandPlannerLoading,
    demandPlannerHasError: state.DemandPlannerReducer.demandPlannerHasError,
    isFileUpLoading: state.UploadDpXlxReducer.isFileUpLoading,
    isFileDownloading: state.DownloadXlxReducer.isFileDownloading,
    demandPlannerSecMat: state.DemandPlannerReducer.demandPlannerSecMat,
    isDemandPlannerSecMatLoading: state.DemandPlannerReducer.isDemandPlannerSecMatLoading,
    demandPlannerSecMatSaleMsku: state.DemandPlannerReducer.demandPlannerSecMatSaleMsku,
    isDemandPlannerSecMatSaleMskuLoading: state.DemandPlannerReducer.isDemandPlannerSecMatSaleMskuLoading,
    isDemandPlannerSecYoyLoading: state.DemandPlannerReducer.isDemandPlannerSecYoyLoading,
    demandPlannerSecYoy: state.DemandPlannerReducer.demandPlannerSecYoy
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getCategory: () => {
      return dispatch(CategoryMiddleware.getCategory());
    },
    getBrands: () => {
      return dispatch(BrandsMiddleware.getBrands());
    },
    getSkus: () => {
      return dispatch(SkusMiddleware.getSkus());
    },
    getRegions: () => {
      return dispatch(RegionsMiddleware.getRegions());
    },
    getDemandDriver: () => {
      return dispatch(DemandDriverMiddleware.getDemandDriver());
    },
    getDemandPlanner: (
      page,
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedYear,
      weekFrom,
      weekTo,
      selectedForecast,
      selectedWeekFrom,
      selectedCOTC
    ) => {
      return dispatch(
        DemandPlannerMiddleware.getDemandPlanner(
          page,
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedYear,
          weekFrom,
          weekTo,
          selectedForecast,
          selectedWeekFrom,
          selectedCOTC
        )
      );
    },
    downloadXlx: (
      page,
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedYear,
      weekFrom,
      weekTo,
      selectedForecast,
      selectedWeekFrom,
      selectedCOTC,
      isMonthly
    ) => {
      return dispatch(
        DownloadDPXlxMiddleware.downloadXlx(
          page,
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedYear,
          weekFrom,
          weekTo,
          selectedForecast,
          selectedWeekFrom,
          selectedCOTC,
          isMonthly
        )
      );
    },
    uploadXlx: (data) => {
      return dispatch(UploadDPXlxMiddleware.uploadXlx(data));
    },
    getDemandPlannerSecMat: (
      selectedCategory,
      selectedBrand,
      selectedSku,
    ) => {
      return dispatch(
        DemandPlannerMiddleware.getDemandPlannerSecMat(
          selectedCategory,
          selectedBrand,
          selectedSku,
        )
      );
    },
    getDemandPlannerSecMatSaleMsku: (
      selectedSku
    ) => {
      return dispatch(
        DemandPlannerMiddleware.getDemandPlannerSecMatSaleMsku(
          selectedSku
        )
      )
    },
    getDemandPlannerSecYoy: (
      selectedCategory,
      selectedBrand,
      selectedSku,
    ) => {
      return dispatch(
        DemandPlannerMiddleware.getDemandPlannerSecYoy(
          selectedCategory,
          selectedBrand,
          selectedSku,
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(DemandPlanner);
